import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

let playerId = 0;

const initialOptions = {
  clientId: "AXY6Rh6QCW5-0YRuFd5ZfVV57hgu9V7e_CZmgDA9oT3TERbWtzmgAAjf_athT1aGcUI0fw8FZuSOlkKC", // Replace with your actual client ID
  dataNamespace: "paypal_sdk", // Adding this resolves potential conflicts
  vault: "true"
};



const onCreateSubscription = (data,actions) => {
  return actions.subscription.create({
          /* Creates the subscription */
          plan_id: 'P-734189570U4610748NITGDIY',   
          custom_id : playerId
  });
}

const PaypalModule = (values) => {
  playerId = values.props;
  let func = values.onApprove;
  let isEnabled = !values.errored;
  if (isEnabled) {
    return (<div><PayPalScriptProvider options={initialOptions}><PayPalButtons 
          style={{ shape: 'pill',
                   color: 'blue',
                   layout: 'vertical',
                   label: 'subscribe' }}
          createSubscription={(data, actions) => onCreateSubscription(data, actions)}
          onApprove={(data, actions) => func(data, actions)}
        /></PayPalScriptProvider></div>)
  }

  return (<div>
    <p>Your account's premium membership state has changed. Our system is propagating the information and should be resolved shortly. If this state persists, please email contact@cwcreations.net</p>
    </div>);
}

export default PaypalModule;